<template>
  <div v-if="event" class="flex justify-start items-center">
    <p class="text-secondary8">{{ event.nominalValue }} {{ currency }}</p>
  </div>
</template>

<script lang="ts">
  import { NominalValue } from '@/services/api/models'
  import { computed, defineComponent } from 'vue'
  import { useStore } from 'vuex'

  export default defineComponent({
    name: 'IssuanceCard',
    components: {},
    props: {
      event: {
        type: Object as () => NominalValue | undefined,
        required: true
      }
    },
    setup() {
      const store = useStore()
      const currency = computed(() => store.getters['organizations/currency'])

      return { currency }
    }
  })
</script>
